/**
 * Payment Bridge
 * 
 * Handles in-app purchases and payments.
 * UNAVAILABLE on web - requires native store integration (Google Play/App Store).
 */

import { UnavailableBridge } from '../BaseBridge'

export class PaymentBridge extends UnavailableBridge {
  readonly bridgeName = 'Payment'
  readonly featureName = 'In-App Purchases'
  readonly methods = ['purchase', 'getProducts', 'getPurchases', 'consume', 'restore']
}

